import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountReadContext } from '@context/AccountContextContext'
import { useProductReadContext } from '@context/ProductContext'

import { PageSection } from '@ui/components/PageSection'

import { isAccountPendingDocumentVerificationStatus } from '@utils/AccountAccess/accountDocumentStatuses'
import { isKycVerified } from '@utils/AccountAccess/accountKYCStatuses'

import { isAccountDetailedActivated } from '@model/AccountDetailedDto'

import { Sumsub } from '@global/sumsub/Sumsub'
import { SumsubThankYouPage } from '@global/sumsub/SumsubThankYouPage'

import { useScrollToTop } from '@hooks/useScrollToTop'

import styles from './SumsubProfilePage.module.scss'

export const SumsubProfilePage: React.FC = () => {
  useScrollToTop()
  const { t } = useTranslation()
  const { account } = useAccountReadContext()
  const { product } = useProductReadContext()
  const isEveryInfoLocked =
    account?.isAdditionalInfoLocked &&
    account?.isPersonalInfoLocked &&
    account?.isAddressInfoLocked &&
    account?.isPaymentInfoLocked

  const showPending =
    (isAccountPendingDocumentVerificationStatus(account) && isKycVerified(account, product)) ||
    (account?.isVerificationExpedited && !isAccountDetailedActivated(account) && isEveryInfoLocked)

  if (showPending) return <SumsubThankYouPage />

  return (
    <div className={styles.sumsubProfilePage}>
      <PageSection title={t('Verification')} />
      <Sumsub />
    </div>
  )
}
